import { Draggable } from "react-beautiful-dnd";
import { Card, CardContent, CardMedia, Stack, Typography, Box } from "@mui/material";
import { Content } from "@/types";
import { getThumbnailImage } from "@/utils/media";
import { useAppSelector } from "@/hooks";
import Price from "@/components/Price";

// Cast RBD components to fix React 18 type incompatibility
const DraggableComp = Draggable as any;

interface Props {
  product: Content;
  index: number;
}

const ProductCard = ({ product, index }: Props) => {
  const activeOrganization = useAppSelector((s) => s.ui.activeOrganization);
  const thumb = getThumbnailImage({
    file: product.images,
    organizationId: activeOrganization,
    size: "150x150",
  });

  return (
    <DraggableComp draggableId={product.id} index={index}>
      {(provided: import("react-beautiful-dnd").DraggableProvided, snapshot: import("react-beautiful-dnd").DraggableStateSnapshot) => (
        <Card
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          variant="outlined"
          sx={{
            cursor: "grab",
            userSelect: "none",
            opacity: snapshot.isDragging ? 0.85 : 1,
            boxShadow: snapshot.isDragging ? 4 : 0,
            transition: "box-shadow 0.2s, opacity 0.2s",
            border: "none",
            borderRadius: 0
          }}
        >
          <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              {thumb ? (
                <CardMedia
                  component="img"
                  image={thumb}
                  sx={{ width: 44, height: 44, borderRadius: 0, objectFit: "cover", flexShrink: 0 }}
                />
              ) : (
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 1,
                    bgcolor: "action.hover",
                    flexShrink: 0,
                  }}
                />
              )}
              <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                <Typography variant="body1" noWrap>
                  {product.title}
                </Typography>
              </Box>
              <Typography
                variant="body2"
                fontWeight="medium"
                color="text.secondary"
                sx={{ flexShrink: 0 }}
              >
                <Price currency="NIO">{product.price != 0 ? product.price : (product.startingPrice ?? 0)}</Price>
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      )}
    </DraggableComp>
  );
};

export default ProductCard;
